<div class="save-confirm-pop-up">
  <div>
    <p [innerHTML]="confirmMessage"></p>
  </div>
  <div *ngIf="additionalInfo !== '' || additionalInfo !== undefined"
       class="additional-info-container"
  >
    <p [innerHTML]="additionalInfo"
       class="additional-info-text"
    ></p>
  </div>
  <div class="compact-button-group">
    <button id="confirmation-dialog-confirm_button"
            class="btn-compact btn-green"
            mat-button
            type="button"
            (click)="confirmClick()"
    >{{ confirmText | anessaTranslation: trigger }}</button>
    <button id="confirmation-dialog-reject_button"
            class="btn-compact btn-red"
            mat-button
            type="button"
            (click)="rejectClick()"
    >{{ rejectText | anessaTranslation: trigger }}</button>
  </div>
</div>
